import {NgModule} from '@angular/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {MatSelectModule} from '@angular/material/select';
import {MatIconModule} from '@angular/material/icon';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MultipleSelectFilterComponent} from './multiple-select-filter.component';
import {IonicModule} from '@ionic/angular';
import {ContentModule} from '../../../../shared/directives/content.module';
import {ContentModalModule} from '../../../../shared/directives/content-modal.module';
import {LoadingModule} from '../../../../components/common/loading/loading.module';
import {KeepHtmlPipeModule} from '../../pipe/keep-html.pipe';

@NgModule({
    declarations: [
        MultipleSelectFilterComponent,
    ],
    exports: [
        MultipleSelectFilterComponent,
        ContentModule,
        ContentModalModule,
    ],
    imports: [
        ReactiveFormsModule,
        FormsModule,
        MatSelectModule,
        MatToolbarModule,
        MatFormFieldModule,
        MatIconModule,
        NgxMatSelectSearchModule,
        MatSlideToggleModule,
        CommonModule,
        ContentModule,
        LoadingModule,
        IonicModule,
        KeepHtmlPipeModule
    ]
})
export class MultipleSelectFilterModule {
}
